<template>
    <vx-card class="limited-max-width" id="ss-third-step">
      <div>
        <header-step-process-component
          v-bind:step="step">
        </header-step-process-component>
        <!-- <div v-if="commercialOffer.type == 'PAQUETES'"> -->
          <span class="title-style modify-title" style="display:inline-block; margin-bottom:8px">Cuantifica tu necesidad mensual</span>
          <span class="subtitle-style modify-subtitle" style="display:inline-block; opacity: 0.7;">
            Selecciona las prestaciones a complementar e introduce tu gasto o necesidad mensual.  
            Te recomendaremos la cobertura adecuada y el coste de la misma. 
            Luego, la decisión es tuya.
          </span>

          <div v-if="commercialOffer.type == 'SOCIALSECURITY'">
          <input-form-social-security
            v-bind:commercialOffer="commercialOffer"
            v-bind:code="code"
            v-bind:next="next"
            v-bind:previus="previus"
          >
          </input-form-social-security>
        </div>
      </div>


    </vx-card>
</template>

<script>
/* eslint-disable */
import VxCard from '../../components/vx-card/VxCard.vue'
import HeaderStepProcessComponent from '../components/eprevision-components/header/HeaderStepProcessComponent.vue';
import InputFormSocialSecurity from '../components/eprevision-components/inputFormSocialSecurity/InputFormSocialSecurity.vue'
import axios from '../../http/axios/index.js'
export default {
  components: {
      VxCard,
      HeaderStepProcessComponent,

      InputFormSocialSecurity
    },
    data() {
      return {
        step: 2,
        code: this.$route.params.code,
        next: "social-security/fourth",
        previus: "social-security/second",
        dataStored: null,
        commercialOffer: null,

      }
    },
    created() {
      this.$vs.loading.close()

      this.dataStored = JSON.parse(localStorage.getItem(this.code))
      this.commercialOffer = this.dataStored.commercialOffer



    },

}
</script>
